import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import FocusModeTimer from 'components/FocusModeTimer';
import {useMobile} from 'utils/hooks';
import {Button} from 'letrus-ui';
import styles from './Header.module.scss';

interface HeaderProps {
  title: string;
  subtitle?: string;
  onGoBack?(): void;
  onExit?(): void;
  showExitButton?: boolean;
  setShouldShowComparisonModal?(status: boolean): void;
  isRewrite?: boolean;
  shouldShowComparisonButton?: boolean;
  getReviewComparisonActivities?: () => void;
  isFocusModeActive?: boolean;
  remainingSeconds?: number;
  effectiveTimeSeconds?: number;
  isExpired?: boolean;
}

function Header({
  title,
  subtitle,
  onGoBack,
  onExit,
  showExitButton = false,
  setShouldShowComparisonModal,
  isRewrite,
  shouldShowComparisonButton,
  getReviewComparisonActivities,
  isFocusModeActive = false,
  remainingSeconds = 0,
  effectiveTimeSeconds = 0,
  isExpired = false,
}: HeaderProps): JSX.Element {
  const {isMobile} = useMobile();

  return (
    <nav data-focusid="header">
      <ul className={styles.container}>
        <li className={styles.leftElement}>
          <Button
            variant="tertiary"
            onClick={onGoBack}
            className={styles.goBackButton}
            aria-label="Voltar"
          >
            <FontAwesomeIcon icon="chevron-left" color="#FF4410" size="lg" />
          </Button>

          <div className={styles.titleWrapper}>
            <h1
              className={`${styles.title} ${
                isRewrite && isMobile ? styles.rewriteTitleMobile : ''
              }`}
            >
              {title}
            </h1>

            {subtitle && <p>{subtitle}</p>}
          </div>
        </li>

        {showExitButton && (
          <li className={styles.buttons}>
            {isFocusModeActive && (
              <FocusModeTimer
                remainingSeconds={remainingSeconds}
                effectiveTimeSeconds={effectiveTimeSeconds}
                isExpired={isExpired}
                isInHeader
              />
            )}

            {isRewrite && shouldShowComparisonButton && (
              <Button
                variant={isMobile ? 'primary' : 'secondary'}
                onClick={() => {
                  setShouldShowComparisonModal?.(true);
                  if (isMobile) getReviewComparisonActivities?.();
                }}
              >
                {isMobile
                  ? 'Comparar atividade'
                  : 'Comparar com texto anterior'}
              </Button>
            )}

            <Button
              onClick={onExit}
              aria-label="Sair"
              data-focusid="exitButton"
              variant={isMobile ? 'tertiary' : 'primary'}
            >
              {isMobile ? (
                <FontAwesomeIcon icon="xmark" color="#FF4410" size="2x" />
              ) : (
                'Sair'
              )}
            </Button>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Header;
